module.exports = __webpack_public_path__ + "static/media/walkie-talkie.9cb22c00.svg";